import { Box, Chip, Grid, Stack, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import { BLUE_COLOR, RED_COLOR } from '../../../../../../constants/ColorsConst';
import { dateformat, toPorcentajeHelper } from '../../../../../../helpers';
import { useNotification } from '../../../../../../helpers/Notification';
import BotonComponent from '../../../../../dashboard/components/BotonNuevo';
import {
  deletePevaActividadesAction,
  setActivoPevaActividadesAction,
} from '../../../peva_actividades/PevaActividadesAction';
import { setActivoPlanevaTemasAction } from '../../../planeva_temas/PlanevaTemasAction';
import { setActivoPtemEvaluacionesAction } from '../../../ptem_evaluaciones/PtemEvaluacionesAction';
import { setDetallesPlanEvaluacionAction } from '../../PlanEvaluacionAction';

const ActividadesPlanEvaluacion = ({
  isEdit,
  setOpenModalForm,
  isDesc = false,
  setTipo,
  planEvaluacion,
  evaluacion,
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const pevaActividadesStore = Redux.useSelector(
    (state) => state.pevaActividades,
  );

  const lista = evaluacion.instrumentos.sort(
    (a, b) =>
      dateformat(a.fecha, { dateOnly: true }) -
      dateformat(b.fecha, { dateOnly: true }),
  );

  return (
    <Grid container spacing={1}>
      {lista.map((el) => (
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: grey[200],
              p: 1,
              borderRadius: '10px',
              border:
                pevaActividadesStore.activo?.id === el.id
                  ? `solid 1.5px ${
                      planEvaluacionStore.detalles.deleteActividad
                        ? RED_COLOR
                        : BLUE_COLOR
                    }`
                  : null,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                sx={{ fontSize: 14, fontWeight: 'bold', color: BLUE_COLOR }}
              >
                <Typography
                  sx={{
                    fontSize: '8pt',
                    fontWeight: 'bold',
                    mr: 1,
                    color: 'black',
                  }}
                >
                  Actividad:
                </Typography>
                {el.instrumento.nombre}{' '}
                {el.fecha ? null : (
                  <Chip
                    label="Sin fecha de inicio"
                    size="small"
                    color="error"
                  />
                )}
              </Typography>
              <Stack direction="row" alignItems="end">
                <Typography sx={{ fontWeight: 'bold', fontSize: 16, mr: 1 }}>
                  {toPorcentajeHelper(
                    el.ponderacion,
                    100,
                    entidadesStore.ajustes.ponderacion,
                  )}
                  %
                </Typography>
                <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
                  {el.ponderacion} Pts
                </Typography>
              </Stack>
            </Stack>
            {el.fecha ? (
              <Typography>
                <strong>Fecha:</strong>{' '}
                {dateformat(el.fecha, { inverse: true })}
              </Typography>
            ) : (
              <Typography>
                <strong>Falta la fecha de entrega:</strong>
              </Typography>
            )}
            {!isDesc ? null : el.desc ? (
              <Typography sx={{ mb: 1 }}>{el.desc}</Typography>
            ) : (
              el.instrumento.desc && (
                <Typography sx={{ mb: 1 }}>{el.instrumento.desc}</Typography>
              )
            )}
            {isEdit && (
              <Stack direction="row" justifyContent="flex-end">
                {planEvaluacionStore.detalles.deleteActividad &&
                pevaActividadesStore.activo?.id === el.id ? (
                  <Stack direction="column" alignItems="flex-end" spacing={1}>
                    <Typography variant="body1" color="initial" align="center">
                      {' '}
                      Seguro que desea eliminar esta evaluación
                    </Typography>
                    <div>
                      <BotonComponent
                        click={() => {
                          deletePevaActividadesAction(
                            { dispatch, notify },
                            planEvaluacion.id,
                            el.id,
                          );
                          setDetallesPlanEvaluacionAction(dispatch, null, null);
                          setActivoPevaActividadesAction(dispatch, null);
                        }}
                        green
                        text="SI"
                        checkIcon
                        mr={2}
                      />
                      <BotonComponent
                        click={() => {
                          setActivoPevaActividadesAction(dispatch, null);
                          setDetallesPlanEvaluacionAction(dispatch, null, null);
                        }}
                        red
                        text="NO"
                        closeIcon
                      />
                    </div>
                  </Stack>
                ) : (
                  <Stack direction="row" spacing={1}>
                    <BotonComponent
                      icon
                      tooltip="Editar"
                      editIcon
                      click={() => {
                        const { temas } = planEvaluacionStore.activo;
                        const tema = temas.find((xTema) =>
                          xTema.evaluaciones.some((xEvaluacion) =>
                            xEvaluacion.instrumentos.some(
                              (xInstrumento) => xInstrumento.id === el.id,
                            ),
                          ),
                        );

                        setDetallesPlanEvaluacionAction(dispatch, null, null);
                        setActivoPlanevaTemasAction(dispatch, tema);
                        setActivoPtemEvaluacionesAction(dispatch, evaluacion);
                        setActivoPevaActividadesAction(dispatch, el);
                        setTipo(2);
                        setOpenModalForm(true);
                      }}
                    />
                    <BotonComponent
                      icon
                      tooltip="Eliminar"
                      deleteIcon
                      click={() => {
                        setActivoPevaActividadesAction(dispatch, el);
                        setDetallesPlanEvaluacionAction(
                          dispatch,
                          'deleteActividad',
                          true,
                        );
                      }}
                    />
                  </Stack>
                )}
              </Stack>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default ActividadesPlanEvaluacion;
